"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slowScrollToElementById = void 0;
var slowScrollToElementById = function (elementId) {
    var element = document.getElementById(elementId);
    if (element) {
        var top_1 = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: top_1, behavior: 'smooth' });
    }
};
exports.slowScrollToElementById = slowScrollToElementById;
